
<!-- Contenedor información -->
<div class="p-grid p-m-0 p-jc-center p-px-4 p-px-md-3 p-py-5 p-py-md-6 bg-blanco">
  <div class="p-col-12 p-d-flex p-flex-column p-text-center">
    <h1 style="font-weight: 700; font-size: 1.4rem;">Preguntas frecuentes</h1>
    <p class="p-m-0">¿Tienes alguna duda o problema? Revisa nuestras preguntas frecuentes.</p>
  </div>
  <div *ngIf="!loading" class="p-col-12 p-sm-10 p-md-8 p-lg-7 p-xl-5 p-mt-4">
    <p-accordion *ngFor="let p of preguntas">
      <p-accordionTab [header]="p.pregunta" >
        <div [innerHTML]="p.descripcion"></div>
      </p-accordionTab>
    </p-accordion>
  </div>

</div>

